import WD from "./WD.webp";
import amd from "./amd.webp";
import asus from "./asus.webp";
import dahua from "./dahua.webp";
import dell from "./dell.webp";
import gigabyte from "./gigabyte.webp";
import intel from "./intel.webp";
import lenovo from "./lenovo.webp";
import msi from "./msi.webp";
import samsung from "./samsung.webp";

export { amd, asus, dahua, dell, gigabyte, intel, lenovo, msi, samsung, WD };
